import React, { useState } from 'react';
import { Users } from 'lucide-react';
import ReservasPage from './ReservasPage';
import ComunicadosPage from './ComunicadosPage';
import VotacionesPage from './VotacionesPage';
import DocumentosPage from './DocumentosPage';

const TABS = [
    { id: 'areas', label: 'Áreas Comunes', component: ReservasPage },
    { id: 'comunicados', label: 'Comunicados', component: ComunicadosPage },
    { id: 'votaciones', label: 'Votaciones', component: VotacionesPage },
    { id: 'documentos', label: 'Documentos', component: DocumentosPage }
];

const ComunidadPage = () => {
    const [activeTab, setActiveTab] = useState('areas');

    const ActiveComponent = TABS.find(tab => tab.id === activeTab)?.component;

    return (
        <div className="space-y-6">
            {/* Header */}
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                <div className="flex items-center gap-3">
                    <div className="p-2 rounded-lg bg-purple-500/20">
                        <Users className="text-purple-400" size={24} />
                    </div>
                    <div>
                        <h1 className="text-2xl font-bold text-white">Comunidad</h1>
                        <p className="text-slate-400">Comunicación, votaciones y gestión de áreas comunes</p>
                    </div>
                </div>
            </div>

            {/* Tabs */}
            <div className="border-b border-slate-700">
                <div className="flex gap-2">
                    {TABS.map(tab => (
                        <button
                            key={tab.id}
                            onClick={() => setActiveTab(tab.id)}
                            className={`
                px-6 py-3 font-medium transition-all relative
                ${activeTab === tab.id
                                    ? 'text-purple-400 border-b-2 border-purple-400'
                                    : 'text-slate-400 hover:text-white'
                                }
              `}
                        >
                            {tab.label}
                        </button>
                    ))}
                </div>
            </div>

            {/* Content */}
            <div>
                {ActiveComponent && <ActiveComponent />}
            </div>
        </div>
    );
};

export default ComunidadPage;
